// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"yR-z","inlineTitle":"zR-z","sponsoredAdsWrapper":"AR-z","marketplaceRecosWrapper":"BR-z"};